import Model from "../Model";

class Countrytops extends Model{

    buildUrl ({ param }) {
        return ['/country', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Countrytops;